import React from "react";
import { Link } from "react-router-dom";
import "../css/SliderTabs.css";

const SliderTabs = () => {
  return (
    <div className="slider-tabs-container">
      <Link to="/contact" className="tab-left blue-bg">
        SCHEDULE CAMPUS TOUR
      </Link>

      <Link to="/admission" className="tab-right orange-bg">
        ADMISSIONS OPEN 2026-27
      </Link>
    </div>
  );
};

export default SliderTabs;